import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Slider from 'react-slick';
import { MDBProgress } from 'mdbreact';
import CountUp from 'react-countup';
import Header from '../layout/Header';

export class Digital_services extends Component {
    render() {
        return (
            <div className="site-main">
                <Header/>
                {/* page-title */}
                <div className="ttm-page-title-row">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-12"> 
                                <div className="title-box">
                                    <div className="page-title-heading">
                                        <h1 className="title">Digital Services</h1>
                                        </div>{/* /.page-title-captions */}
                                        <div className="breadcrumb-wrapper">
                                        <span>
                                            <a title="Homepage" href={process.env.PUBLIC_URL + '/'}>&nbsp;&nbsp;Home</a>
                                        </span>
                                        <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                                        <span>Digital-Services</span>
                                    </div>  
                                </div>
                            </div>{/* /.col-md-12 */}  
                        </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}
                <section class="ttm-row progressbar-section clearfix">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                {/* ttm_single_image-wrapper */}
                                <div className="ttm_single_image-wrapper">
                                    <img className="img-fluid" src="images/bg-image/col-bgimage-4.jpg" alt="" />
                                </div>{/* ttm_single_image-wrapper end */}
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <div class="ttm-bg pt-20 pb-20 pl-20 res-1199-pl-0 res-991-mt-10 res-991-pb-0">
                                    <div class="ttm-col-wrapper-bg-layer ttm-bg-layer">
                                        <div class="ttm-col-wrapper-bg-layer-inner"></div>
                                    </div>
                                    <div class="layer-content">
                                        <div class="position-relative">
                                            <div class="section-title">
                                                <div class="title-header mb-0">
                                                <h2 class="detail-page-heading">The best digital agency around the world</h2>
                                                </div>
                                                <div class="title-desc">
                                                <p class="res-991-pb-0">Web designing in a powerful way of just not a profession, however for our Company. We have a tendency to believe the idea.</p>
                                                </div>
                                            </div>
                                            <div>
                                                <h3 class="sd-sub-heading mt-30">Our achievements</h3>
                                                <p class="sd-text">Web designing in a powerful way of just not a profession, however for our Company. We have a tendency to believe the idea that smart looking,tendency to believe the idea that smart looking.</p>
                                            </div>
                                            <div class="progress-bar-main border-0 res-991-mt-20">
                                                <div class="ttm-progress-bar style1" data-percent="90%">
                                                    <div className="ttm-progress-bar">
                                                        <div className="progress-bar-title float-left">Creative thinking</div>
                                                        <label className="float-right">90%</label>
                                                        <MDBProgress className="w-100" material value={90}></MDBProgress>
                                                    </div>
                                                </div>
                                                <div className="ttm-progress-bar">
                                                    <div className="progress-bar-title float-left">Communication</div>{/* progress-bar-title */}
                                                    <label className="float-right">80%</label>
                                                    <MDBProgress className="w-100" material value={80}></MDBProgress>
                                                </div>
                                                <div className="ttm-progress-bar">
                                                    <div className="progress-bar-title float-left">Research</div>{/* progress-bar-title */}
                                                    <label className="float-right">75%</label>
                                                    <MDBProgress className="w-100" material value={75}></MDBProgress>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row padding_top_zero-section process-section clearfix">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-5 col-md-12">
                                <div class="section-title mb-0">
                                    <div class="title-header">
                                    <h2 class="title">Stay up to date</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="title-line"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="service-process-box">
                                    <div class="row align-items-center">
                                        <div class="col-lg-5">
                                            <div class="service-processbox-content">
                                                <h3 class="sd-sub-heading">We are always looking for a creative person who can fill up our achievements</h3>
                                                <p class="sd-text mb-0">Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7">
                                            <div class="service-process-image res-991-mt-30">
                                                <img width="746" height="186" class="img-fluid w-100" src="images/single-img-11.png" loading="lazy" alt="images" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="service-process-box">
                                    <div class="row align-items-center">
                                        <div class="col-lg-7 img-order-md-1 ">
                                            <div class="service-process-image">
                                                <img width="746" height="186" class="img-fluid w-100" src="images/single-img-12.png" loading="lazy" alt="images" />
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <div class="service-processbox-content res-991-mt-30">
                                                <h3 class="sd-sub-heading">Giving your business some orignal ideas who can fill up our achievements</h3>
                                                <p class="sd-text mb-0">Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="service-process-box res-991-mt-0 res-991-mb-0">
                                    <div class="row align-items-center">
                                        <div class="col-lg-5">
                                            <div class="service-processbox-content">
                                                <h3 class="sd-sub-heading">We are always looking for a creative person who can fill up our achievements</h3>
                                                <p class="sd-text mb-0">Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7">
                                            <div class="service-process-image res-991-mt-30">
                                                <img width="746" height="186" class="img-fluid w-100" src="images/single-img-14.png" loading="lazy" alt="images" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row padding_top_zero-section clearfix">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="section-title mb-0">
                                    <div class="title-header">
                                    <h2 class="title">Commercial planning</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12">
                                <div class="title-line res-991-mt-20"></div>
                            </div>
                        </div>
                        <div class="row mt-25">
                            <div class="col-lg-5 col-md-12">
                                <div class="ttm-bg ttm-bgcolor-gradient spacing-3">
                                    <Slider className="row slick_slider" arrows={false} dots={false}>
                                        <div className="col-lg-12">
                                            <div class="testimonials-style2">
                                                <div class="testimonials-style1-content">
                                                <div class="testimonial-ttm-description">
                                                    <div class="ttm-box-highlight">
                                                    </div>
                                                    <div class="ttm-ratting-stars">
                                                    <ul class="ratting-stars">
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                    </ul>
                                                    </div>
                                                </div>
                                                <div class="testimonial-ttm-box-desc">
                                                    <p class="testimonial-ttm-box-desc-p">Our team discussed every single detail to make sure Creatives Planet is the most versatile and unique template created so far. No coding skills.</p>
                                                </div>
                                                <div class="ttm-box-footer">
                                                    <h3 class="testimonial-caption-h3">Aenna Bell</h3>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div class="testimonials-style2">
                                                <div class="testimonials-style1-content">
                                                <div class="testimonial-ttm-description">
                                                    <div class="ttm-box-highlight">
                                                    </div>
                                                    <div class="ttm-ratting-stars">
                                                    <ul class="ratting-stars">
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                    </ul>
                                                    </div>
                                                </div>
                                                <div class="testimonial-ttm-box-desc">
                                                    <p class="testimonial-ttm-box-desc-p">Our team discussed every single detail to make sure Creatives Planet is the most versatile and unique template created so far. No coding skills.</p>
                                                </div>
                                                <div class="ttm-box-footer">
                                                    <h3 class="testimonial-caption-h3">Aenna Bell</h3>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div class="testimonials-style2">
                                                <div class="testimonials-style1-content">
                                                <div class="testimonial-ttm-description">
                                                    <div class="ttm-box-highlight">
                                                    </div>
                                                    <div class="ttm-ratting-stars">
                                                    <ul class="ratting-stars">
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                        <li class="ratting-stars-items">
                                                        <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                        </li>
                                                    </ul>
                                                    </div>
                                                </div>
                                                <div class="testimonial-ttm-box-desc">
                                                    <p class="testimonial-ttm-box-desc-p">Our team discussed every single detail to make sure Creatives Planet is the most versatile and unique template created so far. No coding skills.</p>
                                                </div>
                                                <div class="ttm-box-footer">
                                                    <h3 class="testimonial-caption-h3">Aenna Bell</h3>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="overflow-hiden pl-20 res-1199-pl-0 res-1199-pt-30 res-991-pl-0">
                                    <div>
                                    <h3 class="sd-sub-heading">We are always looking for a creative person</h3>
                                    <p class="sd-text">Web designing in a powerful way of just not a profession, however for our Company. We have a tendency to believe the idea.</p>
                                    </div>
                                    <div class="ttm-col-bgcolor-yes ttm-bgcolor-darkgrey ttm-textcolor-white col-bg-img-five ttm-col-bgimage-yes ttm-bg mt-15">
                                        <div class="ttm-col-wrapper-bg-layer ttm-bg-layer ttm-bgcolor-darkgrey">
                                            <div class="ttm-col-wrapper-bg-layer-inner ttm-bgcolor-darkgrey"></div>
                                        </div>
                                        <div class="layer-content spacing-4 position-relative">
                                            <div class="fid-block-content">
                                                <h3 class="sd-sub-heading text-white">One platform endlesso oportunities</h3>
                                                <p class="sd-text ttm-textcolor-white mb-30">We have a tendency to believe the idea that smart looking,tendency to believe the idea that smart looking.</p>
                                            </div>
                                            <div class="row g-0 ttm-vertical_sep">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                                    <div class="ttm-fid inside style2">
                                                        <div class="ttm-fid-contents text-center">
                                                            <CountUp start={0} end={25} duration={3} />
                                                            <h3 class="ttm-fid-title">Years of experience</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                                    <div class="ttm-fid inside style2">
                                                        <div class="ttm-fid-contents text-center">
                                                            <CountUp start={0} end={15} duration={1} />
                                                            <span>k</span>
                                                            <h3 class="ttm-fid-title">Happy freelancers</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                                    <div class="ttm-fid inside style2">
                                                        <div class="ttm-fid-contents text-center">
                                                            <CountUp start={0} end={60} duration={5} />
                                                            <h3 class="ttm-fid-title">Project done</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </div>
            )
    }
}


export default Digital_services;